import React, {Component} from 'react';
import marketStyle from '../css/markets.css';
import Button from './button';

class FifthOrMorePlay extends Component {
    render() {
        let store = this.props.store;
        let markets = this.props.markets;
        markets = markets.filter((mkt) => mkt.id === '167-4' || mkt.id === '167-9' || mkt.id === '167-14')
        return (
            <div className={marketStyle.marketGroup}>
                <Button store={store} market={markets[0]}/>
                <Button store={store} market={markets[1]}/>
                <Button store={store} market={markets[2]}/>
            </div>
        );
    }
}

export default FifthOrMorePlay;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/firstDown/components/fifthOrMorePlay.js